export const backendUnavailableSubscribers = new Set();

// pathname is the page that was open when the request failed - a stray
// background/secondary request firing after the user has already navigated
// away shouldn't blank out whatever page they're on now.
export const reportBackendUnavailable = (pathname) => {
    backendUnavailableSubscribers.forEach(fn => fn(pathname));
};
